/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Photo_CaptionsInputs */

const en_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Photo Captions`)
};

const es_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leyendas de Fotos`)
};

const fr_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Légendes des Photos`)
};

const de_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bildunterschriften`)
};

const ja_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`写真のキャプション`)
};

const zh_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`照片说明`)
};

const ar_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعليقات الصور`)
};

const id_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keterangan Foto`)
};

const it_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Didascalie Foto`)
};

const ru_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подписи к Фото`)
};

const pt_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legendas de Fotos`)
};

const ko_photo_captions = /** @type {(inputs: Photo_CaptionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`사진 캡션`)
};

/**
* | output |
* | --- |
* | "Photo Captions" |
*
* @param {Photo_CaptionsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const photo_captions = /** @type {((inputs?: Photo_CaptionsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Photo_CaptionsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_photo_captions(inputs)
	if (locale === "es") return es_photo_captions(inputs)
	if (locale === "fr") return fr_photo_captions(inputs)
	if (locale === "de") return de_photo_captions(inputs)
	if (locale === "ja") return ja_photo_captions(inputs)
	if (locale === "zh") return zh_photo_captions(inputs)
	if (locale === "ar") return ar_photo_captions(inputs)
	if (locale === "id") return id_photo_captions(inputs)
	if (locale === "it") return it_photo_captions(inputs)
	if (locale === "ru") return ru_photo_captions(inputs)
	if (locale === "pt") return pt_photo_captions(inputs)
	return ko_photo_captions(inputs)
});